import { useTableStyles } from "../commonStyles/tableStyles";
import { EntriesTableContent } from "./EntriesTableContent";
import { ManageEntriesTableContent } from "./ManageEntriesTableContent";
import { Box } from "@mui/material";

export const EntriesTable = ({
    entries,
    confirmed,
    showBibs,
    showSeeds,
    seedIsPosition,
    isTeams,
    teamRoles,
    manageEntries,
    isAlternates,
    updateFailedPayments,
    clearFailedPayments,
    statusTitle = "Status",
}) => {
    const tableClasses = useTableStyles();

    return (
        <Box component="table" className={tableClasses.table} marginBottom={3}>
            {manageEntries ? (
                <ManageEntriesTableContent
                    confirmed={confirmed}
                    entries={entries}
                    showBibs={showBibs}
                    isAlternates={isAlternates}
                    isTeams={isTeams}
                    showSeeds={showSeeds}
                    seedIsPosition={seedIsPosition}
                    statusTitle={statusTitle}
                    updateFailedPayments={updateFailedPayments}
                    clearFailedPayments={clearFailedPayments}
                    teamRoles={teamRoles}
                />
            ) : (
                <EntriesTableContent
                    entries={entries}
                    showBibs={showBibs}
                    isAlternates={isAlternates}
                    isTeams={isTeams}
                    seedIsPosition={seedIsPosition}
                />
            )}
        </Box>
    );
};
